module.exports = __webpack_public_path__ + "static/media/csrd_updapt_logo.e897363c.svg";